module.exports = __webpack_public_path__ + "img/Group 326.3558a5f3.svg";